import { useEffect, useState } from "react";
import { API } from "@/services/API";

export const useMapboxKey = (shouldGet) => {
  const [mapboxAccessKey, setMapboxAccessKey] = useState("");
  useEffect(() => {
    if (shouldGet && !mapboxAccessKey) {
      API.get("/mapbox/access-token").then((response) => {
        setMapboxAccessKey(response);
      });
    }
  }, [shouldGet]);

  return mapboxAccessKey;
};
